<template>
    <div>
      <div v-if="!$page.props.user.is_temp_user">
        <verify-your-email></verify-your-email>
      </div>
      <div v-else>
        <register-as-full-user></register-as-full-user>
      </div>
    </div>
</template>

<script>


    import VerifyYourEmail from "@/Pages/Auth/VerifyYourEmail";
    import RegisterAsFullUser from "@/Pages/Auth/RegisterAsFullUser";
    export default {
        components: {
          RegisterAsFullUser,
          VerifyYourEmail

        },
    }
</script>
